import type { TripDetail, Status, Occasion } from '../../types';

/**
 * Client-side AND filter for trip list status and occasion.
 */
export function filterTrips(
  trips: TripDetail[],
  statusFilter: Status | 'ALL',
  occasionFilter: Occasion | 'ALL'
): TripDetail[] {
  return trips.filter(trip => {
    const statusMatch = statusFilter === 'ALL' || trip.status === statusFilter;
    const occasionMatch =
      occasionFilter === 'ALL' || trip.occasions.includes(occasionFilter);
    return statusMatch && occasionMatch;
  });
}
